export const getTrayTitle = (title) => {
  if (title) {
    let trayTitle = title
    let finalTitle = ""
   let isNextLine =  trayTitle.includes("/n") || trayTitle.split(/\\n/)
   if (isNextLine) {
      trayTitle = trayTitle.includes("/n") || trayTitle.split(/\\n/)
      for(let i =0;i< trayTitle?.length ; i++) {
        finalTitle += `<p>${trayTitle[i]}</p>`
      }
   }
  return finalTitle
  }else {
    return ""
  }
  }

  const getFontFamily = (name,weight) => {
    if(name) {
    const isApplicableFontsList = ["Acumin Pro","HelveticaNeue","Lato"]
    let isApplicableFonts = isApplicableFontsList.includes(name)
    let fontName = name?.split(" ")?.join("");
   if (isApplicableFonts && (weight === "extraBold" || weight === "heavy" || weight === "condensedBold")) return `${fontName}Black`
   if (isApplicableFonts && (weight === "bold")) return `${fontName}Bold`
   if (isApplicableFonts && (weight === "semiBold" || weight === "medium")) return `${fontName}SemiBold`
   if (name === "Acumin Pro" && (weight === "regular" || weight === "light" || weight === "extraLight" || weight === "thin" || weight === "")) return `${name}` //Regular
   if (isApplicableFonts && (weight === "regular" || weight === "light" || weight === "extraLight" || weight === "thin" || weight === "")) return `${fontName}Regular`
   if (name === "Lato" && (weight === "italic")) return "LatoItalic"
   if (name === "Lato" && (weight === "boldItalic")) return "LatoBoldItalic"
   if (name === "Lato") return "LatoRegular"
   if (name === "Lorimer No2" && (weight === "italic" || weight === "boldItalic")) return `${fontName}BlackItalic`
   if (name === "Lorimer No2") return `${name}`
   if (name === "RocGrotesk") return "RocGrotesk"
   
   if (name === "Termina" && weight === "regular" ) return `${name}` //Regular
   if (name === "Termina" && weight === "bold" ) return `${name}Bold`
   if (name === "Termina" && (weight === "semiBold" || weight === "medium")) return `${name}Medium`
   if (name === "Termina" && (weight === "extraBold" || weight === "heavy" || weight === "condensedBold")) return `${name}Heavy`
   if (name === "Termina" && weight === "extraLight" ) return `${name}ExtraLight`
   if (name === "Termina" && weight === "light" ) return `${name}Light`
   if (name === "Termina" && weight === "thin" ) return `${name}Thin`
   
   if (name === "MD Nichrome") return "MDNichrome"
   if (name === "Sequel Sans") return "SequelSans"
   if (name === "HelveticaNeue") return "HelveticaNeueRegular"
   if (name === "Roboto") return "Roboto"
  }
}
  
const getStyle = (fontSetting, settings, key) => ({
  fontFamily: getFontFamily(fontSetting?.[key]?.fontFamilyName, fontSetting?.[key]?.fontWeight),
  fontSize: fontSetting?.[key]?.fontSize,
  color: settings?.[key]
})

export const getFontsStyles = (fontSetting, settings) => {
  let articleTitleStyles = {
    fontFamily: getFontFamily(fontSetting?.articleTitle?.fontFamilyName, fontSetting?.articleTitle?.fontWeight),
    fontSize: fontSetting?.articleTitle?.fontSize
  }
  let articleDescriptionStyles = {
    fontFamily: getFontFamily(fontSetting?.articleDescription?.fontFamilyName, fontSetting?.articleDescription?.fontWeight),
    fontSize: fontSetting?.articleDescription?.fontSize
  }
  let gamePlayerpreviewTitleStyles = {
    fontFamily: getFontFamily(fontSetting?.previewTitle?.fontFamilyName, fontSetting?.previewTitle?.fontWeight),
    fontSize: fontSetting?.previewTitle?.fontSize
  }
  let gamePlayerpreviewDescriptionStyles = {
    fontFamily: getFontFamily(fontSetting?.previewDescription?.fontFamilyName, fontSetting?.previewDescription?.fontWeight),
    fontSize: fontSetting?.previewDescription?.fontSize
  }
//
  let ctaHeadingStyles = {
    fontFamily: getFontFamily(fontSetting?.ctaHeading?.fontFamilyName, fontSetting?.ctaHeading?.fontWeight),
    fontSize: fontSetting?.ctaHeading?.fontSize
  }
  let featureItemStyles = {
    fontFamily: getFontFamily(fontSetting?.featureItem?.fontFamilyName, fontSetting?.featureItem?.fontWeight),
    fontSize: fontSetting?.featureItem?.fontSize
  }
  let sectionHeadingStyles = {
    fontFamily: getFontFamily(fontSetting?.sectionHeading?.fontFamilyName, fontSetting?.sectionHeading?.fontWeight),
    fontSize: fontSetting?.sectionHeading?.fontSize
  }

  let planBannerHeadingStyles = {
    fontFamily: getFontFamily(fontSetting?.monetizationCtaHeading?.fontFamilyName, fontSetting?.monetizationCtaHeading?.fontWeight),
    fontSize: fontSetting?.monetizationCtaHeading?.fontSize
  }
  let planBannerSubHeadingStyles = {
    fontFamily: getFontFamily(fontSetting?.monetizationCtaSubTitle?.fontFamilyName, fontSetting?.monetizationCtaSubTitle?.fontWeight),
    fontSize: fontSetting?.monetizationCtaSubTitle?.fontSize
  }
  let planBannerPriceStyles = {
    fontFamily: getFontFamily(fontSetting?.monetizationCtaPrice?.fontFamilyName, fontSetting?.monetizationCtaPrice?.fontWeight),
    fontSize: fontSetting?.monetizationCtaPrice?.fontSize
  }
 
  let tabStyles = {
    fontFamily: getFontFamily(fontSetting?.tab?.fontFamilyName, fontSetting?.tab?.fontWeight),
    fontSize: fontSetting?.tab?.fontSize
  }
  let widgetStyles = {
    fontFamily: getFontFamily(fontSetting?.widget?.fontFamilyName, fontSetting?.widget?.fontWeight),
    fontSize: fontSetting?.widget?.fontSize
  }
  let scoreSummary = {
    fontFamily: getFontFamily(fontSetting?.scoreSummary?.fontFamilyName, fontSetting?.scoreSummary?.fontWeight),
    fontSize: fontSetting?.scoreSummary?.fontSize
  }
  let infoOverlayTitle = {
    fontFamily: getFontFamily(fontSetting?.infoOverlayTitle?.fontFamilyName, fontSetting?.infoOverlayTitle?.fontWeight),
    fontSize: fontSetting?.infoOverlayTitle?.fontSize
  }
  let individualPlayerScore = {
    fontFamily: getFontFamily(fontSetting?.individualPlayerScore?.fontFamilyName, fontSetting?.individualPlayerScore?.fontWeight),
    fontSize: fontSetting?.individualPlayerScore?.fontSize
  }
  let position = {
    fontFamily: getFontFamily(fontSetting?.position?.fontFamilyName, fontSetting?.position?.fontWeight),
    fontSize: fontSetting?.position?.fontSize
  }
  let trayTitle = {
    fontFamily: getFontFamily(fontSetting?.title?.fontFamilyName, fontSetting?.title?.fontWeight),
    fontSize: fontSetting?.title?.fontSize || "18px",
    color: settings?.trayTitleColor
  }
  let traySubTitle = {
    fontFamily: getFontFamily(fontSetting?.subtitle?.fontFamilyName, fontSetting?.subtitle?.fontWeight),
    fontSize: fontSetting?.subtitle?.fontSize,
  }
  let trayItem = {
    fontFamily: getFontFamily(fontSetting?.trayItemTitle?.fontFamilyName, fontSetting?.trayItemTitle?.fontWeight),
    fontSize: fontSetting?.trayItemTitle?.fontSize,
  }
  let teamStyles = {
    fontFamily: getFontFamily(fontSetting?.team?.fontFamilyName, fontSetting?.team?.fontWeight),
    fontSize: fontSetting?.team?.fontSize,
  }
  let scheduleButtonStyles = {
    fontFamily: fontSetting?.buttonFontFamilyName,
    fontSize: fontSetting?.buttonFontSize
  }
  let tray_Item_Title = {
    fontFamily: getFontFamily(fontSetting?.trayItemTitle?.fontFamilyName, fontSetting?.trayItemTitle?.fontWeight),
    fontSize: fontSetting?.trayItemTitle?.fontSize,
  }
  let videoTitle = {
    fontFamily: getFontFamily(fontSetting?.videoTitle?.fontFamilyName, fontSetting?.videoTitle?.fontWeight),
    fontSize: fontSetting?.videoTitle?.fontSize,
  }
  let videoDescription = {
    fontFamily: getFontFamily(fontSetting?.videoDescription?.fontFamilyName, fontSetting?.videoDescription?.fontWeight),
    fontSize: fontSetting?.videoDescription?.fontSize,
  }
  let searchSuggestionTitle = {
    fontFamily: getFontFamily(fontSetting?.searchSuggestionTitle?.fontFamilyName, fontSetting?.searchSuggestionTitle?.fontWeight),
    fontSize: fontSetting?.searchSuggestionTitle?.fontSize,
  }
  let searchSuggestionDate = {
    fontFamily: getFontFamily(fontSetting?.searchSuggestionDate?.fontFamilyName, fontSetting?.searchSuggestionDate?.fontWeight),
    fontSize: fontSetting?.searchSuggestionDate?.fontSize,
  }
  let navigationFonts = {
    fontFamily: getFontFamily(fontSetting?.navigation?.fontFamilyName, fontSetting?.navigation?.fontWeight),
    fontSize: fontSetting?.navigation?.fontSize,
  }
  let buttonFont = {
    fontFamily: getFontFamily(fontSetting?.button?.fontFamilyName, fontSetting?.button?.fontWeight),
    fontSize: fontSetting?.button?.fontSize,
  }
  let teamNameFont = {
    fontFamily: getFontFamily(fontSetting?.teamName?.fontFamilyName, fontSetting?.teamName?.fontWeight),
    fontSize: fontSetting?.teamName?.fontSize,
  }
  let playerNameFont = {
    fontFamily: getFontFamily(fontSetting?.playerName?.fontFamilyName, fontSetting?.playerName?.fontWeight),
    fontSize: fontSetting?.playerName?.fontSize,
  }
  let pointsTitleFont = {
    fontFamily: getFontFamily(fontSetting?.pointsTitle?.fontFamilyName, fontSetting?.pointsTitle?.fontWeight),
    fontSize: fontSetting?.pointsTitle?.fontSize,
  }
  let positionFont = {
    fontFamily: getFontFamily(fontSetting?.position?.fontFamilyName, fontSetting?.position?.fontWeight),
    fontSize: fontSetting?.position?.fontSize,
  }
  let regularSeasonTitleFont = {
    fontFamily: getFontFamily(fontSetting?.regularSeasonTitle?.fontFamilyName, fontSetting?.regularSeasonTitle?.fontWeight),
    fontSize: fontSetting?.regularSeasonTitle?.fontSize,
  }
  let popupHeadingTitleFont = {
    fontFamily: getFontFamily(fontSetting?.popupHeading?.fontFamilyName, fontSetting?.popupHeading?.fontWeight),
    fontSize: fontSetting?.popupHeading?.fontSize,
  }
  let popupCtaTitleFont = {
    fontFamily: getFontFamily(fontSetting?.popupCtaTitle?.fontFamilyName, fontSetting?.popupCtaTitle?.fontWeight),
    fontSize: fontSetting?.popupCtaTitle?.fontSize,
  }
  let popupCtaSubTitleFont = {
    fontFamily: getFontFamily(fontSetting?.popupCtaSubtitle?.fontFamilyName, fontSetting?.popupCtaSubtitle?.fontWeight),
    fontSize: fontSetting?.popupCtaSubtitle?.fontSize,
  }
  let popupPriceFont = {
    fontFamily: getFontFamily(fontSetting?.popupPrice?.fontFamilyName, fontSetting?.popupPrice?.fontWeight),
    fontSize: fontSetting?.popupPrice?.fontSize,
  }
  let popupDetailFont = {
    fontFamily: getFontFamily(fontSetting?.popupDetail?.fontFamilyName, fontSetting?.popupDetail?.fontWeight),
    fontSize: fontSetting?.popupDetail?.fontSize,
  }
  let timerTitleFont = {
    fontFamily: getFontFamily(fontSetting?.timerTitle?.fontFamilyName, fontSetting?.timerTitle?.fontWeight),
    fontSize: fontSetting?.timerTitle?.fontSize,
  }
  let timerValueFont = {
    fontFamily: getFontFamily(fontSetting?.timerValue?.fontFamilyName, fontSetting?.timerValue?.fontWeight),
    fontSize: fontSetting?.timerValue?.fontSize,
  }

  let continueButtonFont = {
    fontFamily: getFontFamily(fontSetting?.continueButton?.fontFamilyName, fontSetting?.continueButton?.fontWeight),
    fontSize: fontSetting?.continueButton?.fontSize,
  }

  let loginButtonFont = {
    fontFamily: getFontFamily(fontSetting?.loginButton?.fontFamilyName, fontSetting?.loginButton?.fontWeight),
    fontSize: fontSetting?.loginButton?.fontSize,
  }
  let loginWallTitleFont = {
    fontFamily: getFontFamily(fontSetting?.loginWallTitle?.fontFamilyName, fontSetting?.loginWallTitle?.fontWeight),
    fontSize: fontSetting?.loginWallTitle?.fontSize,
  }

  let emailWallTitleFont = {
    fontFamily: getFontFamily(fontSetting?.emailWallTitle?.fontFamilyName, fontSetting?.emailWallTitle?.fontWeight),
    fontSize: fontSetting?.emailWallTitle?.fontSize,
  }
  let planFont = {
    fontFamily: getFontFamily(fontSetting?.plan?.fontFamilyName, fontSetting?.plan?.fontWeight),
    fontSize: fontSetting?.plan?.fontSize,
  }

  let subscriptionWallTitleFont = {
    fontFamily: getFontFamily(fontSetting?.subscriptionWallTitle?.fontFamilyName, fontSetting?.subscriptionWallTitle?.fontWeight),
    fontSize: fontSetting?.subscriptionWallTitle?.fontSize,
  }
  let offerCodeBannerDescriptionFont = {
    fontFamily: getFontFamily(fontSetting?.offerCodeBannerDescription?.fontFamilyName, fontSetting?.offerCodeBannerDescription?.fontWeight),
    fontSize: fontSetting?.offerCodeBannerDescription?.fontSize,
  }

  let offerCodeBannerPlanTitleFont = {
    fontFamily: getFontFamily(fontSetting?.offerCodeBannerPlanTitle?.fontFamilyName, fontSetting?.offerCodeBannerPlanTitle?.fontWeight),
    fontSize: fontSetting?.offerCodeBannerPlanTitle?.fontSize,
  }

  let offerCodeBannerPlanOffFont ={
    fontFamily: getFontFamily(fontSetting?.offerCodeBannerPlanOff?.fontFamilyName, fontSetting?.offerCodeBannerPlanOff?.fontWeight),
    fontSize: fontSetting?.offerCodeBannerPlanOff?.fontSize,
  }

  let offerCodeBannerTitleFont ={
    fontFamily: getFontFamily(fontSetting?.offerCodeBannerTitle?.fontFamilyName, fontSetting?.offerCodeBannerTitle?.fontWeight),
    fontSize: fontSetting?.offerCodeBannerTitle?.fontSize,
  }
  let detailPageTitleInfo ={
    fontFamily: getFontFamily(fontSetting?.detailPageTitleInfo?.fontFamilyName, fontSetting?.detailPageTitleInfo?.fontWeight),
    fontSize: fontSetting?.detailPageTitleInfo?.fontSize,
  }
  let detailPageDescriptionInfo ={
    fontFamily: getFontFamily(fontSetting?.detailPageDescriptionInfo?.fontFamilyName, fontSetting?.detailPageDescriptionInfo?.fontWeight),
    fontSize: fontSetting?.detailPageDescriptionInfo?.fontSize,
  }
  let detailPageCategoryInfo ={
    fontFamily: getFontFamily(fontSetting?.detailPageCategoryInfo?.fontFamilyName, fontSetting?.detailPageCategoryInfo?.fontWeight),
    fontSize: fontSetting?.detailPageCategoryInfo?.fontSize,
  }
  let badgeStyles ={
    fontFamily: getFontFamily(fontSetting?.badge?.fontFamilyName, fontSetting?.badge?.fontWeight),
    fontSize: fontSetting?.badge?.fontSize,
  }

  let loginCta = {
    fontFamily: getFontFamily(fontSetting?.loginCta?.fontFamilyName, fontSetting?.loginCta?.fontWeight),
    fontSize: fontSetting?.loginCta?.fontSize,
  }

  let logoutCta = {
    fontFamily: getFontFamily(fontSetting?.logoutCta?.fontFamilyName, fontSetting?.logoutCta?.fontWeight),
    fontSize: fontSetting?.logoutCta?.fontSize,
  }

  let connectTvProviderCta = {
    fontFamily: getFontFamily(fontSetting?.connectTvProviderCta?.fontFamilyName, fontSetting?.connectTvProviderCta?.fontWeight),
    fontSize: fontSetting?.connectTvProviderCta?.fontSize,
  }

  let subscribeNowCta = {
    fontFamily: getFontFamily(fontSetting?.subscribeNowCta?.fontFamilyName, fontSetting?.subscribeNowCta?.fontWeight),
    fontSize: fontSetting?.subscribeNowCta?.fontSize,
  }

  let planFeatures = {
    fontFamily: getFontFamily(fontSetting?.planFeatures?.fontFamilyName, fontSetting?.planFeatures?.fontWeight),
    fontSize: fontSetting?.planFeatures?.fontSize,
  }

  return { offerCodeBannerDescriptionFont,offerCodeBannerPlanTitleFont,offerCodeBannerPlanOffFont,popupHeadingTitleFont,offerCodeBannerTitleFont, popupCtaTitleFont,popupCtaSubTitleFont,popupPriceFont,popupDetailFont, trayTitle, traySubTitle, trayItem, teamStyles, scheduleButtonStyles, videoDescription, videoTitle, tray_Item_Title, articleTitleStyles, articleDescriptionStyles, tabStyles, widgetStyles, searchSuggestionTitle,searchSuggestionDate, navigationFonts, buttonFont, teamNameFont, playerNameFont, pointsTitleFont, positionFont, 
    regularSeasonTitleFont, scoreSummary, infoOverlayTitle, individualPlayerScore, position, timerTitleFont, timerValueFont, continueButtonFont, loginButtonFont, loginWallTitleFont, emailWallTitleFont,
     planFont, subscriptionWallTitleFont, gamePlayerpreviewDescriptionStyles,gamePlayerpreviewTitleStyles, planBannerHeadingStyles, planBannerSubHeadingStyles, planBannerPriceStyles
    , ctaHeadingStyles, featureItemStyles, sectionHeadingStyles,loginCta,logoutCta,connectTvProviderCta,subscribeNowCta,badgeStyles,planFeatures,detailPageCategoryInfo,detailPageDescriptionInfo,detailPageTitleInfo, 
    loginV2Title: getStyle(fontSetting, settings, "title"),
    loginV2InputBoxPlaceholder: getStyle(fontSetting, settings, "inputBoxPlaceholder"),
    loginV2LoginCta: getStyle(fontSetting, settings, "loginCta"),
    loginV2Description: getStyle(fontSetting, settings, "description"),
  }
 }
